// Pages services dédiées (SEO-friendly URLs)
export const SERVICE_PAGES = [
  {
    slug: "depannage-serrurier",
    path: "/depannage-serrurier",
    title: "Dépannage serrurier 24h/24",
    short: "Dépannage urgent",
    headline: "Dépannage serrurier d'urgence",
    metaDesc: "Dépannage serrurier 24h/24, 7j/7. Intervention rapide, devis gratuit, tarifs transparents.",
    image: "https://images.unsplash.com/photo-1614791189661-93412a35af54?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    intro:
      "Une serrure bloquée, une clé cassée, une porte qui claque ? Notre service de dépannage serrurerie est mobilisable jour et nuit, week-ends et jours fériés inclus.",
    bullets: [
      "Intervention en moins de 30 minutes",
      "Devis annoncé par téléphone, sans surprise",
      "Tous types de serrures : cylindre, multipoints, bec-de-cane",
      "Pas de majoration nuit / dimanche abusive",
      "Garantie pièces et main-d'œuvre 2 ans",
    ],
    process: [
      { t: "Vous appelez", d: "Décrochage en moins d'une sonnerie, diagnostic au téléphone." },
      { t: "Devis immédiat", d: "Tarif annoncé clairement avant tout déplacement." },
      { t: "Intervention", d: "Technicien sur place sous 30 min, équipé du matériel adapté." },
      { t: "Garantie 2 ans", d: "Facture détaillée + rapport pour votre assurance." },
    ],
    price: "Devis téléphone gratuit",
    cta: "Appeler pour un dépannage immédiat",
  },
  {
    slug: "ouverture-de-porte",
    path: "/ouverture-de-porte",
    title: "Ouverture de porte sans dégât",
    short: "Ouverture de porte",
    headline: "Ouverture de porte claquée",
    metaDesc: "Ouverture de porte claquée ou bloquée sans dégât. 95% des cas réglés sans casse, intervention en 30 min.",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro:
      "Porte claquée, clé perdue ou cassée, serrure grippée ? Nos techniciens utilisent des outils de crochetage professionnels pour ouvrir votre porte SANS la dégrader dans 95% des cas.",
    bullets: [
      "Ouverture sans dégât (crochetage technique)",
      "Toutes serrures : 3 points, 5 points, A2P*, *, ***",
      "Disponible 24h/24, 7j/7",
      "Aucun dégât = aucun remplacement à payer",
      "Justificatif d'identité et de domicile demandés (sécurité)",
    ],
    process: [
      { t: "Diagnostic visuel", d: "Identification du type de serrure et de la difficulté." },
      { t: "Tentative de crochetage", d: "Ouverture fine, sans abîmer le mécanisme." },
      { t: "Plan B sécurisé", d: "Si crochetage impossible, perçage propre limité au cylindre." },
      { t: "Conseil sécurité", d: "Recommandations pour éviter une nouvelle situation." },
    ],
    price: "Devis gratuit au téléphone",
    cta: "Ma porte est claquée — appeler",
  },
  {
    slug: "blindage-de-porte",
    path: "/blindage-de-porte",
    title: "Blindage de porte haute sécurité",
    short: "Blindage de porte",
    headline: "Blindage de porte d'entrée",
    metaDesc: "Blindage de porte certifié contre l'effraction. Pose sur porte existante ou neuve, certifié A2P.",
    image: "https://images.unsplash.com/photo-1582139329536-e7284fece509?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    intro:
      "Renforcez la sécurité de votre logement avec un blindage de porte certifié A2P BP1, BP2 ou BP3. Pose sur votre porte existante (blindage) ou remplacement par bloc-porte blindé neuf.",
    bullets: [
      "Plaque de blindage en acier sur porte existante",
      "Bloc-porte blindé neuf (Picard, Fichet, Diamant)",
      "Cornières anti-pinces et paumelles renforcées",
      "Serrure multipoints A2P 3 étoiles",
      "Devis gratuit + visite technique offerte",
    ],
    process: [
      { t: "Visite technique", d: "Mesure et conseil sur la solution adaptée à votre porte." },
      { t: "Devis détaillé", d: "Choix du niveau de protection (BP1 / BP2 / BP3)." },
      { t: "Pose en 1 journée", d: "Intervention propre sans détérioration de l'huisserie." },
      { t: "Garantie 5 ans", d: "Pièces certifiées + main-d'œuvre garantie." },
    ],
    price: "Devis sur mesure",
    cta: "Demander un devis blindage",
  },
  {
    slug: "installation-serrure-connectee",
    path: "/installation-serrure-connectee",
    title: "Installation serrure connectée",
    short: "Serrure connectée",
    headline: "Serrure connectée & contrôle d'accès",
    metaDesc: "Installation de serrures connectées Bluetooth/WiFi : Nuki, Yale, Igloohome. Pose et configuration.",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro:
      "Modernisez votre porte avec une serrure connectée pilotable depuis votre smartphone. Idéale pour les locations courte durée, propriétaires occupés ou besoins d'accès partagés.",
    bullets: [
      "Compatibles Nuki, Yale Linus, Igloohome, Tedee",
      "Ouverture par smartphone, code, badge ou empreinte",
      "Codes temporaires pour locataires Airbnb",
      "Conserve votre clé physique en backup",
      "Pose et configuration smartphone incluses",
    ],
    process: [
      { t: "Conseil produit", d: "Choix de la marque adaptée à votre porte et usage." },
      { t: "Pose sans perçage", d: "La plupart s'installent sur la serrure existante." },
      { t: "Configuration app", d: "Paramétrage smartphone + comptes utilisateurs." },
      { t: "Formation utilisation", d: "Démo complète + remise du guide imprimé." },
    ],
    price: "À partir de 350€ pose incluse",
    cta: "Je veux une serrure connectée",
  },
  {
    slug: "depannage-coffre-fort",
    path: "/depannage-coffre-fort",
    title: "Dépannage et ouverture coffre-fort",
    short: "Coffre-fort",
    headline: "Ouverture & dépannage coffre-fort",
    metaDesc: "Ouverture de coffre-fort bloqué, code perdu, serrure HS. Intervention sans destruction du contenu.",
    image: "https://images.unsplash.com/photo-1582139329536-e7284fece509?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    intro:
      "Coffre-fort bloqué, code perdu, batterie morte, serrure cassée ? Nos techniciens spécialisés ouvrent toutes marques de coffres-forts résidentiels et professionnels en préservant son contenu.",
    bullets: [
      "Toutes marques : Hartmann, Fichet, Stark, Phoenix, Yale",
      "Coffres mécaniques, électroniques, biométriques",
      "Ouverture sans destruction du contenu",
      "Remise en service immédiate ou remplacement",
      "Justificatif de propriété requis (légalité)",
    ],
    process: [
      { t: "Vérification légale", d: "Justificatif d'achat ou de propriété demandé." },
      { t: "Diagnostic technique", d: "Type, marque, mode de blocage identifié." },
      { t: "Ouverture spécialisée", d: "Manipulation, décodage ou perçage ciblé." },
      { t: "Remise en service", d: "Reprogrammation code ou remplacement serrure." },
    ],
    price: "Sur devis",
    cta: "Mon coffre est bloqué — appeler",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICE_PAGES.find((s) => s.slug === slug);
